import type { TodayMealSummary } from '../types';

export async function fetchTodayMeals(): Promise<TodayMealSummary> {
  const res = await fetch('/api/employee-dashboard/today-meals');
  if (!res.ok) {
    throw new Error('Failed to fetch today meals');
  }
  return res.json();
}
